import { render } from "./Detail.vue?vue&type=template&id=0384882f"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"
script.render = render

export default script